import get from 'lodash.get';
import { constants } from '@yola/subscription-manager-js';

const {
  hostingPackageFeatureNames: { PREMIUM_BLOCKS },
} = constants;

const premiumBlocksLimit = ({ targetPackage }) => ({
  available: get(targetPackage, ['features', PREMIUM_BLOCKS], false),
});

export default premiumBlocksLimit;
